<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "ClearUpToolList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Dokumente zum Renten Clear-Up Tool"
      new-button-name="Neue(s) Dokument/Information"
      :list-header="tableHeader"
      :category="10"
      :event-to-call-options="{
        table: tableItems,
        showPath: 'RentenClearUpTool',
        redirectPath: 'RentenClearUpToolEdit',
        categoryId: 10,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'renten clear-up tool'
      }"
   new-button-path="ClearUpToolNew"></CMSListCard>
</template>

<style scoped>

</style>
